import BreadCrumb from "Common/BreadCrumb";
import Loader from "Common/Components/Loader";
import TableContainer from "Common/TableContainer";
import React from "react";
import { useTransactions } from "./useTransactions";

const Transactions = () => {
  const { transactions, isLoading, error } = useTransactions();
  console.log("transactions", transactions);

  const columns = [
    { header: "Game Slots", accessorKey: "gameName" },
    { header: "Date", accessorKey: "date" },
    { header: "Total Amount", accessorKey: "totalAmount" },
    { header: "Total Tickets Sold", accessorKey: "totalTicketsSold" },
    { header: "Total Payouts", accessorKey: "totalPayouts" },
    { header: "Status", accessorKey: "status" },
  ];

  return (
    <React.Fragment>
      <BreadCrumb title="Transactions" pageTitle="Dashboard" />
      {isLoading && <Loader />}
      {error && <div className="text-center text-danger">{error.message}</div>}
      <div className="card">
        <div className="card-body">
          {transactions?.length > 0 ? (
            <TableContainer
              columns={columns}
              data={transactions}
              customPageSize={10}
              isPagination={true}
            />
          ) : (
            !isLoading && (
              <div className="text-center">No transactions found.</div>
            )
          )}
        </div>
      </div>
    </React.Fragment>
  );
};

export default Transactions;
